import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SurveySubmissionsToAuditDataGrid } from "src/components/views/erp/surveys/auditing/SurveySubmissionsToAuditDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/surveys/submissions/audit")({
	staticData: { title: i18n.t("surveys_to_audit"), legacyViewKey: "surveySubmissionsToAuditPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SurveySubmissionsToAuditDataGrid />;
}
